module.exports = __webpack_public_path__ + "img/bano-ducha.dd77b7ad.svg";